




import { Component, Vue } from 'vue-property-decorator'
import CallDetail from './components/TicketDetail.vue'

@Component({
  name: 'CreateCall',
  components: {
    CallDetail
  }
})
export default class extends Vue {}
